import api from './api';

export const searchWords = async (params) => {
  const { data } = await api.get('/v1/lexical_entries/search', { params });
  return data;
};

export const browseWords = async (params) => {
  const { data } = await api.get('/v1/lexical_entries/browse', { params });
  return data;
};
